import { registerComponent as G } from "@aileron/icon";
import { unsafeCSS as B, LitElement as N } from "lit";
import { html as w, unsafeStatic as X } from "lit/static-html.js";
import { state as k, query as Y, queryAsync as J, property as l } from "lit/decorators.js";
import { classMap as F } from "lit/directives/class-map.js";
import { ifDefined as y } from "lit/directives/if-defined.js";
const Q = (n) => {
  class e extends n {
    constructor(...i) {
      super(...i), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const s = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(s.getElementsByTagName("link")).findIndex(
        (u) => u.href === this.fontLink
      ) === -1) {
        const u = document.createElement("link");
        u.href = this.fontLink, u.rel = "stylesheet", document.head.appendChild(u);
      }
    }
  }
  return e;
}, Z = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.\\!container{width:100%!important}.container{width:100%}@media (min-width: 24.375rem){.\\!container{max-width:24.375rem!important}.container{max-width:24.375rem}}@media (min-width: 50rem){.\\!container{max-width:50rem!important}.container{max-width:50rem}}@media (min-width: 80rem){.\\!container{max-width:80rem!important}.container{max-width:80rem}}@media (min-width: 90rem){.\\!container{max-width:90rem!important}.container{max-width:90rem}}.static{position:static}.inline{display:inline}.flex{display:flex}.table{display:table}.hidden{display:none}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}', ee = B(Z), C = "aileron-color-scheme", O = "aileron-color-scheme-change", te = (n) => {
  const t = class t extends n {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (s) => {
        s.detail ? this.setAttribute(C, s.detail) : this.removeAttribute(C);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        O,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const s = document.documentElement.getAttribute(
        C
      );
      s && this.setAttribute(C, s);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        O,
        this.handleSchemeSwitch
      );
    }
  };
  t.styles = [
    ee,
    n.styles ?? []
  ];
  let e = t;
  return e;
}, P = te(Q(N));
function D(n, e, t) {
  const i = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...t
  });
  return n.dispatchEvent(i), i;
}
function ie(n, e) {
  function t(i) {
    if (!i || i === document || i === window)
      return null;
    i.assignedSlot && (i = i.assignedSlot);
    const s = i.closest(n);
    return s || t(i.getRootNode().host);
  }
  return t(e);
}
class se extends Event {
  constructor(e) {
    super("formdata"), this.formData = e;
  }
}
class ne extends FormData {
  constructor(e) {
    super(e), this.form = e, e.dispatchEvent(new se(this));
  }
  append(e, t) {
    let i = this.form.elements[e];
    if (i || (i = document.createElement("input"), i.type = "hidden", i.name = e, this.form.appendChild(i)), this.has(e)) {
      const s = this.getAll(e), a = s.indexOf(i.value);
      a !== -1 && s.splice(a, 1), s.push(t), this.set(e, s);
    } else
      super.append(e, t);
    i.value = t;
  }
}
function ae() {
  const n = document.createElement("form");
  let e = !1;
  return document.body.append(n), n.addEventListener("submit", (t) => {
    new FormData(t.target), t.preventDefault();
  }), n.addEventListener("formdata", () => e = !0), n.dispatchEvent(new Event("submit", { cancelable: !0 })), n.remove(), e;
}
function q() {
  !window.FormData || ae() || (window.FormData = ne, window.addEventListener("submit", (n) => {
    n.defaultPrevented || new FormData(n.target);
  }));
}
document.readyState === "complete" ? q() : window.addEventListener("DOMContentLoaded", () => q());
class oe {
  constructor(e, t) {
    (this.host = e).addController(this), this.options = {
      form: (i) => ie("form", i),
      name: (i) => i.name,
      value: (i) => i.value,
      disabled: (i) => i.disabled,
      reportValidity: (i) => typeof i.reportValidity == "function" ? i.reportValidity() : !0,
      ...t
    }, this.options.form(this.host) && (this.options.form(this.host).noValidate = !0), this.handleFormData = this.handleFormData.bind(this), this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  hostConnected() {
    var e;
    this.form = (e = this.options) == null ? void 0 : e.form(this.host), this.form && (this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit));
  }
  hostDisconnected() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form = void 0);
  }
  handleFormData(e) {
    const t = this.options.disabled(this.host), i = this.options.name(this.host), s = this.options.value(this.host);
    !t && typeof i == "string" && typeof s < "u" && (Array.isArray(s) ? s.forEach((a) => {
      e.formData.append(i, a.toString());
    }) : e.formData.append(i, s.toString()));
  }
  handleFormSubmit(e) {
    const t = this.options.disabled(this.host);
    this.form && !t && (e.preventDefault(), e.stopImmediatePropagation());
  }
  submit(e) {
    if (this.form) {
      const t = document.createElement("button");
      t.type = "submit", t.style.position = "absolute", t.style.width = "0", t.style.height = "0", t.style.clipPath = "inset(50%)", t.style.overflow = "hidden", t.style.whiteSpace = "nowrap", e && ["formaction", "formmethod", "formnovalidate", "formtarget"].forEach((i) => {
        e.hasAttribute(i) && t.setAttribute(i, e.getAttribute(i));
      }), this.form.append(t), t.click(), t.remove();
    }
  }
}
class re {
  constructor(e, ...t) {
    this.slotNames = [], (this.host = e).addController(this), this.slotNames = t, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((e) => {
      var t;
      if (e.nodeType === e.TEXT_NODE && ((t = e.textContent) == null ? void 0 : t.trim()) !== "")
        return !0;
      if (e.nodeType === e.ELEMENT_NODE) {
        const i = e;
        if (i.tagName.toLowerCase() === "adc-visually-hidden")
          return !1;
        if (!i.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(e) {
    return this.host.querySelector(`:scope > [slot="${e}"]`) !== null;
  }
  test(e) {
    return e === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(e);
  }
  hostConnected() {
    var e;
    (e = this.host.shadowRoot) == null || e.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var e;
    (e = this.host.shadowRoot) == null || e.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(e) {
    var i, s;
    const t = e.target;
    ((i = this.slotNames) != null && i.includes("[default]") && !t.name || t.name && ((s = this.slotNames) != null && s.includes(t.name))) && this.host.requestUpdate();
  }
}
function H(n, e) {
  const t = {
    waitUntilFirstUpdate: !1,
    ...e
  };
  return (i, s) => {
    const { update: a } = i;
    if (n in i) {
      const c = n;
      i.update = function(u) {
        if (u.has(c)) {
          const f = u.get(c), b = this[c];
          f !== b && (!t.waitUntilFirstUpdate || this.hasUpdated) && this[s](
            f,
            b
          );
        }
        a.call(this, u);
      };
    }
  };
}
const le = (n, e, t) => Array.prototype.filter.call(n, e, t), de = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let ce = (n = 21) => {
  let e = "", t = crypto.getRandomValues(new Uint8Array(n |= 0));
  for (; n--; )
    e += de[t[n] & 63];
  return e;
};
const ue = '.aileron-select__form-wrapper{font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-weight:400;font-variation-settings:"wght" 400;font-size:1rem;line-height:1.5rem;text-transform:none;display:flex;flex-direction:column;gap:8px;color:#006dc0;position:relative}.aileron-select__error-icon{color:#d6001b}.aileron-select__label{font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-weight:500;font-variation-settings:"wght" 500;font-size:.875rem;line-height:1.25rem;text-transform:none;display:inline-flex;align-items:center;gap:4px;color:#5e6d7a}.aileron-select__input-wrapper{display:flex;flex-direction:row;align-items:center;background-color:#fff;border:1px solid #869199;border-radius:4px;overflow:hidden;position:relative}.aileron-select__input-wrapper:hover{background-color:#e0f2ff}.aileron-select__input-wrapper:active{outline:2px #006DC0 solid;outline-offset:2px;background-color:#d6edff}.aileron-select--focus{outline:2px #3AABFF solid;outline-offset:2px}.aileron-select__leading-icon{color:#1b1f23;padding:12px 8px 12px 0;display:inline-block}.aileron-select__input{padding:12px 36px 12px 16px;background-color:inherit;flex-grow:1;cursor:pointer;width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;text-overflow:ellipsis}.aileron-select__input:active{outline:0;border:0}.aileron-select__input:focus{outline:0}.aileron-select__secondary-select{position:absolute;top:0;left:0;height:0;width:0;z-index:-1}.aileron-select__secondary-select.aileron-select--active{z-index:1;height:auto;width:auto;top:110%}.aileron-select__caret{position:absolute;right:12px;pointer-events:none;display:flex;align-items:center}.aileron-select__error-text{font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-weight:400;font-variation-settings:"wght" 400;font-size:.75rem;line-height:1rem;text-transform:none;color:#d6001b}.aileron-select__help-text{font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-weight:400;font-variation-settings:"wght" 400;font-size:.75rem;line-height:1rem;text-transform:none;color:#1b1f23}.aileron-select__option{color:#1b1f23}.aileron-select--active{background-color:#d6edff}.aileron-select--disabled{color:#d0dae0}.aileron-select--disabled .aileron-select__input-wrapper{background-color:#edf1f3;border-color:#e6ecef}.aileron-select--invalid .aileron-select__input-wrapper{border-color:#d6001b}.aileron-select--required .aileron-select__label:after{display:inline-block;content:"";background-color:#d6001b;border-radius:9999px;height:.375rem;width:.375rem;margin-left:.25rem;box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}';
var he = Object.defineProperty, pe = Object.getOwnPropertyDescriptor, d = (n, e, t, i) => {
  for (var s = i > 1 ? void 0 : i ? pe(e, t) : e, a = n.length - 1, c; a >= 0; a--)
    (c = n[a]) && (s = (i ? c(e, t, s) : c(s)) || s);
  return i && s && he(e, t, s), s;
};
const p = "aileron-select", m = {
  formWrapper: `${p}__form-wrapper`,
  inputWrapper: `${p}__input-wrapper`,
  input: `${p}__input`,
  label: `${p}__label`,
  helpText: `${p}__help-text`,
  clearButton: `${p}__clear-button`,
  leadingIcon: `${p}__leading-icon`,
  errorIcon: `${p}__error-icon`,
  errorText: `${p}__error-text`,
  option: `${p}__option`,
  caret: `${p}__caret`,
  secondarySelect: `${p}__secondary-select`,
  required: `${p}--required`,
  disabled: `${p}--disabled`,
  invalid: `${p}--invalid`,
  hidden: `${p}--hidden`,
  focus: `${p}--focus`,
  active: `${p}--active`
}, V = class V extends P {
  constructor(e) {
    super(), this.observerMutation = null, this.formSubmitController = new oe(this), this.hasSlotController = new re(
      this,
      "helper-text"
    ), this.randomId = `adc-select-${ce(6)}`, this.elementHasDisplayName = !1, this.hasFocus = !1, this.pristine = !0, this.handleMutation = () => {
      this.requestUpdate();
    }, this.disabled = !1, this.helperText = "", this.invalid = !1, this.labelText = "", this.autocomplete = "", this.placeholder = "", this.readonly = !1, this.required = !1, this.liveValidation = !1, this.requiredValidityMessage = "Please fill out this field.", this.active = !1, this.size = 0, this.validityMessage = "", this.handleClickOutside = (t) => {
      var s;
      const i = (s = this.shadowRoot) == null ? void 0 : s.querySelector("#inputWrapper");
      !(i != null && i.contains(t.target)) && t.target !== this && (this.active = !1);
    }, this.customElementString = e;
  }
  /**
   * on input, dispatch event containing value
   * @param event.target
   * @fires adc-select-item-selected
   * @ignore
   */
  handleInput({ target: e }) {
    const { value: t } = e;
    this.value = t, this.setCustomValidity(""), this.handleValidity(), this.selectedEvent(t);
  }
  selectedEvent(e) {
    const { eventSelect: t } = this.constructor;
    this.dispatchEvent(
      new CustomEvent(t, {
        bubbles: !0,
        composed: !0,
        detail: {
          value: e
        }
      })
    );
  }
  renderItems(e) {
    const { selectorItem: t, selectorLeafItem: i } = this.constructor, s = le(
      e.childNodes,
      (a) => a.nodeType === Node.ELEMENT_NODE && a.matches(t)
    );
    return w`${s.map((a) => {
      const c = a.hasAttribute("disabled"), u = a.getAttribute("label-text"), f = a.hasAttribute("selected"), b = a.getAttribute("value"), S = a.getAttribute("display-name"), v = a.textContent;
      return a.matches(i) ? w` <option
            class=${m.option}
            ?disabled="${c}"
            label="${y(v || u || "")}"
            ?selected="${f}"
            .value=${b || ""}
            data-display-name="${y(S || void 0)}"
          >
            ${v || u}
          </option>` : w`
            <optgroup
              class=${m.option}
              ?disabled="${c}"
              label="${y(u || "")}"
            >
              ${this.renderItems(a)}
            </optgroup>
          `;
    })}`;
  }
  handleValidity() {
    this.pristine = !1, this.liveValidation && (this.invalid = !this.dropdown.checkValidity());
  }
  /**
   * When not disabled, append name and value to formData event object.
   * @param event
   */
  handleFormdata(e) {
    const { formData: t } = e, { disabled: i, name: s, value: a } = this;
    i || (this.handleValidity(), t.append(s, a));
  }
  /**
   * get the length of the select node.
   */
  get length() {
    return this.dropdown.length;
  }
  /**
   * get the options for the select node.
   */
  get options() {
    return this.dropdown.options;
  }
  /**
   * get the type for the select node.
   */
  get type() {
    return this.dropdown.type;
  }
  get multiple() {
    return !1;
  }
  get selectedIndex() {
    return this.dropdown.selectedIndex;
  }
  /**
   * @ignore
   */
  set selectedIndex(e) {
    this.dropdown.selectedIndex = e, this.value = this.dropdown.value;
  }
  reportValidity() {
    return this.dropdown.reportValidity();
  }
  setCustomValidity(e) {
    if (e != null && e.trim()) {
      this.invalid = !0, this.validityMessage = e;
      return;
    }
    this.invalid = !1, this.validityMessage = "";
  }
  focus(e) {
    this.dropdown.focus(e);
  }
  blur() {
    this.dropdown.blur();
  }
  handleBlur() {
    this.hasFocus = !1, this.handleValidity(), D(this, "adc-blur");
  }
  handleDisabledChange() {
    this.disabled && (this.dropdown.disabled = this.disabled, this.invalid = !this.dropdown.checkValidity());
  }
  async handleFocus() {
    this.hasFocus || (this.hasFocus = !0, this.elementHasDisplayName && (this.active = !0, (await this.secondarySelect).focus()), D(this, "adc-focus"));
  }
  handleLabelClick() {
    this.focus();
  }
  handleInvalid() {
    this.invalid = !0;
  }
  async handleValueChange() {
    await this.updateComplete, this.updateValueSecondarySelect(), this.handleValidity(), D(this, "adc-change");
  }
  async updateValueSecondarySelect() {
    if (this.elementHasDisplayName) {
      const e = await this.secondarySelect;
      e.value = this.value, this.updateSelectedElement(
        e.options[e.selectedIndex]
      );
    }
  }
  /**
   * Disable observerMutation to prevent memory leak in ie11
   */
  connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-select"), G(
      this.customElementString ? this.customElementString + "-select" : "adc-select"
    ), !!window.MSInputMethodContext && !!document.documentMode || (this.observerMutation = new MutationObserver(this.handleMutation), this.observerMutation.observe(this, {
      attributes: !0,
      childList: !0,
      subtree: !0
    }));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.elementHasDisplayName && document.removeEventListener("click", this.handleClickOutside), this.observerMutation && (this.observerMutation.disconnect(), this.observerMutation = null);
  }
  updated(e) {
    const t = Array.from(
      this.querySelectorAll(".adc-select-item")
    );
    if (!this.elementHasDisplayName && t.length > 0 && (this.elementHasDisplayName = t.every((i) => i.displayName), this.elementHasDisplayName && (this.value && this.updateValueSecondarySelect(), document.addEventListener("click", this.handleClickOutside))), e.has("pristine") && this.liveValidation && !this.pristine && (this.invalid = !this.dropdown.checkValidity()), e.has("value")) {
      const { value: i } = this;
      this.dropdown.value = i || "";
    }
    e.has("disabled") && (this.disabled ? this.dropdown.setAttribute("disabled", "disabled") : this.dropdown.removeAttribute("disabled"));
  }
  handleSecondInput({ target: e }) {
    const t = e.options[e.selectedIndex];
    this.value = t.value, this.updateSelectedElement(t), this.selectedEvent(t == null ? void 0 : t.value);
  }
  async updateSelectedElement(e) {
    this.selectedElement = e, this.requestUpdate(), await this.updateComplete, this.dropdown.value = e == null ? void 0 : e.value, this.handleValidity();
  }
  handleSecondaryClick() {
    this.active = !this.active;
  }
  handleSecondaryKeyDown({ key: e }) {
    (e === "Esc" || e === "Escape" || e === "Enter") && this.active && (this.active = !1);
  }
  handleSecondayBlur() {
    this.active = !1;
  }
  createTagName(e) {
    return X(
      this.customElementString ? this.customElementString + e : "adc" + e
    );
  }
  render() {
    var E, $;
    const {
      disabled: e,
      helperText: t,
      invalid: i,
      labelText: s,
      required: a,
      name: c,
      autocomplete: u,
      placeholder: f,
      validityMessage: b,
      requiredValidityMessage: S,
      value: v,
      elementHasDisplayName: x
    } = this, T = i ? w`
          <div
            id="formRequirement"
            class=${m.errorText}
            id="validity-message"
            aria-live="polite"
          >
            <slot name="validity-message"
              >${b || S}</slot
            >
          </div>
        ` : w`
          <div id="helperText" class=${m.helpText}>
            <slot name="helper-text">${t}</slot>
          </div>
        `;
    return w`
      <div
        class="${F({
      [m.formWrapper]: !0,
      [m.invalid]: this.invalid,
      [m.disabled]: this.disabled,
      [m.required]: this.required
    })}"
      >
        <label
          part="form-control-label"
          for="${y(this.selectId ? this.selectId : this.randomId)}"
          class=${m.label}
        >
          ${i ? w` <span class=${m.errorIcon}>
            <${this.createTagName("-select-icon")}
            icon="signal:error"
            size="16"
          ></${this.createTagName("-select-icon")}>
              </span>` : void 0}
          <slot name="label-text">${s}</slot>
        </label>
        <div
          class="${F({
      [m.inputWrapper]: !0,
      [m.focus]: this.hasFocus
    })}"
          ?data-invalid="${i}"
          id="inputWrapper"
        >
          <select
            id="${y(this.selectId ? this.selectId : this.randomId)}"
            part="trigger"
            .autocomplete=${u}
            class=${m.input}
            name=${c}
            .disabled=${e}
            .required=${a}
            size="${x ? 0 : this.size}"
            aria-invalid=${i ? "true" : "false"}
            aria-describedby=${y(
      i ? "validity-message" : void 0
    )}
            aria-label="${y(this.a11yLabel)}"
            aria-description="${y(this.a11yDescription)}"
            @blur=${this.handleBlur}
            @focus=${this.handleFocus}
            @change=${this.handleInput}
            @invalid=${this.handleInvalid}
          >
            ${x ? w`<option
                  value="${(E = this.selectedElement) == null ? void 0 : E.value}"
                  style="display:none"
                >
                  ${(($ = this.selectedElement) == null ? void 0 : $.dataset.displayName) || f}
                </option>` : !f || v ? void 0 : w`
                  <option disabled selected value="" style="display:none">
                    ${f}
                  </option>
                `}
            ${x ? void 0 : this.renderItems(this)}
          </select>
          ${x && !this.disabled ? w`<select
                id="secondarySelect"
                size="${this.size || 2}"
                class=${F({
      [m.secondarySelect]: !0,
      [m.active]: this.active
    })}
                @change=${this.handleSecondInput}
                @click=${this.handleSecondaryClick}
                @keydown=${this.handleSecondaryKeyDown}
                @blur=${this.handleSecondayBlur}
              >
                ${this.renderItems(this)}
              </select>` : void 0}

          <div class=${m.caret}>
            <adc-icon icon="navigation:caret-down" size="24"></adc-icon>
          </div>
        </div>
        ${T}
      </div>
    `;
  }
  /**
   * @ignore
   */
  static get selectorItem() {
    return "adc-select-item-group,adc-select-item";
  }
  /**
   * @ignore
   */
  static get selectorLeafItem() {
    return "adc-select-item";
  }
  /**
   * @ignore
   */
  static get eventSelect() {
    return "adc-select-item-selected";
  }
};
V.styles = [P.styles || [], B(ue)];
let r = V;
d([
  k()
], r.prototype, "selectedElement", 2);
d([
  k()
], r.prototype, "elementHasDisplayName", 2);
d([
  k()
], r.prototype, "hasFocus", 2);
d([
  k()
], r.prototype, "pristine", 2);
d([
  Y('select[part="trigger"]')
], r.prototype, "dropdown", 2);
d([
  J("#secondarySelect")
], r.prototype, "secondarySelect", 2);
d([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "disabled", 2);
d([
  l({ attribute: "helper-text" })
], r.prototype, "helperText", 2);
d([
  l()
], r.prototype, "id", 2);
d([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "invalid", 2);
d([
  l({ type: String, attribute: "label-text" })
], r.prototype, "labelText", 2);
d([
  l({ type: Boolean })
], r.prototype, "multiple", 1);
d([
  l()
], r.prototype, "autocomplete", 2);
d([
  l()
], r.prototype, "name", 2);
d([
  l()
], r.prototype, "pattern", 2);
d([
  l()
], r.prototype, "placeholder", 2);
d([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "readonly", 2);
d([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "required", 2);
d([
  l({ type: Boolean, attribute: "live-validation", reflect: !0 })
], r.prototype, "liveValidation", 2);
d([
  l({ attribute: "required-validity-message" })
], r.prototype, "requiredValidityMessage", 2);
d([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "active", 2);
d([
  l({ type: Number, reflect: !0 })
], r.prototype, "size", 2);
d([
  l({ type: String, reflect: !0, attribute: "select-id" })
], r.prototype, "selectId", 2);
d([
  l({ type: Number })
], r.prototype, "selectedIndex", 1);
d([
  l({ attribute: "validity-message" })
], r.prototype, "validityMessage", 2);
d([
  l()
], r.prototype, "value", 2);
d([
  l({ type: String, attribute: "a11y-label" })
], r.prototype, "a11yLabel", 2);
d([
  l({ type: String, attribute: "a11y-description" })
], r.prototype, "a11yDescription", 2);
d([
  H("disabled", { waitUntilFirstUpdate: !0 })
], r.prototype, "handleDisabledChange", 1);
d([
  H("value")
], r.prototype, "handleValueChange", 1);
try {
  customElements.define("adc-select", r), console.warn(
    "@aileron/select is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/select"
  );
} catch {
}
function me(n) {
  try {
    customElements.define(`${n}-select`, class extends r {
    });
  } catch {
  }
}
var fe = Object.defineProperty, U = (n, e, t, i) => {
  for (var s = void 0, a = n.length - 1, c; a >= 0; a--)
    (c = n[a]) && (s = c(e, t, s) || s);
  return s && fe(e, t, s), s;
};
class L extends N {
  constructor() {
    super(...arguments), this.disabled = !1, this.labelText = "";
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-select-item-group");
  }
}
U([
  l({ type: Boolean, reflect: !0 })
], L.prototype, "disabled");
U([
  l({ reflect: !0, attribute: "label-text" })
], L.prototype, "labelText");
try {
  customElements.define("adc-select-item-group", L), console.warn("@aileron/select is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/select");
} catch {
}
function be(n) {
  try {
    customElements.define(`${n}-select-item-group`, class extends L {
    });
  } catch {
  }
}
var we = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
(function(n, e) {
  (function(t, i) {
    i();
  })(we, function() {
    function t(s) {
      var a = !0, c = !1, u = null, f = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
      };
      function b(o) {
        return !!(o && o !== document && o.nodeName !== "HTML" && o.nodeName !== "BODY" && "classList" in o && "contains" in o.classList);
      }
      function S(o) {
        var W = o.type, z = o.tagName;
        return !!(z === "INPUT" && f[W] && !o.readOnly || z === "TEXTAREA" && !o.readOnly || o.isContentEditable);
      }
      function v(o) {
        o.classList.contains("focus-visible") || (o.classList.add("focus-visible"), o.setAttribute("data-focus-visible-added", ""));
      }
      function x(o) {
        o.hasAttribute("data-focus-visible-added") && (o.classList.remove("focus-visible"), o.removeAttribute("data-focus-visible-added"));
      }
      function T(o) {
        o.metaKey || o.altKey || o.ctrlKey || (b(s.activeElement) && v(s.activeElement), a = !0);
      }
      function E(o) {
        a = !1;
      }
      function $(o) {
        b(o.target) && (a || S(o.target)) && v(o.target);
      }
      function j(o) {
        b(o.target) && (o.target.classList.contains("focus-visible") || o.target.hasAttribute("data-focus-visible-added")) && (c = !0, window.clearTimeout(u), u = window.setTimeout(function() {
          c = !1;
        }, 100), x(o.target));
      }
      function K(o) {
        document.visibilityState === "hidden" && (c && (a = !0), M());
      }
      function M() {
        document.addEventListener("mousemove", h), document.addEventListener("mousedown", h), document.addEventListener("mouseup", h), document.addEventListener("pointermove", h), document.addEventListener("pointerdown", h), document.addEventListener("pointerup", h), document.addEventListener("touchmove", h), document.addEventListener("touchstart", h), document.addEventListener("touchend", h);
      }
      function R() {
        document.removeEventListener("mousemove", h), document.removeEventListener("mousedown", h), document.removeEventListener("mouseup", h), document.removeEventListener("pointermove", h), document.removeEventListener("pointerdown", h), document.removeEventListener("pointerup", h), document.removeEventListener("touchmove", h), document.removeEventListener("touchstart", h), document.removeEventListener("touchend", h);
      }
      function h(o) {
        o.target.nodeName && o.target.nodeName.toLowerCase() === "html" || (a = !1, R());
      }
      document.addEventListener("keydown", T, !0), document.addEventListener("mousedown", E, !0), document.addEventListener("pointerdown", E, !0), document.addEventListener("touchstart", E, !0), document.addEventListener("visibilitychange", K, !0), M(), s.addEventListener("focus", $, !0), s.addEventListener("blur", j, !0), s.nodeType === Node.DOCUMENT_FRAGMENT_NODE && s.host ? s.host.setAttribute("data-js-focus-visible", "") : s.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
    }
    if (typeof window < "u" && typeof document < "u") {
      window.applyFocusVisiblePolyfill = t;
      var i;
      try {
        i = new CustomEvent("focus-visible-polyfill-ready");
      } catch {
        i = document.createEvent("CustomEvent"), i.initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
      }
      window.dispatchEvent(i);
    }
    typeof document < "u" && t(document);
  });
})();
try {
  document.body.querySelector(":focus-visible");
} catch {
}
const ye = (n) => {
  class e extends n {
    constructor(...i) {
      super(...i);
    }
  }
  return e;
};
var ve = Object.defineProperty, ge = Object.getOwnPropertyDescriptor, I = (n, e, t, i) => {
  for (var s = i > 1 ? void 0 : i ? ge(e, t) : e, a = n.length - 1, c; a >= 0; a--)
    (c = n[a]) && (s = (i ? c(e, t, s) : c(s)) || s);
  return i && s && ve(e, t, s), s;
};
class A extends ye(N) {
  constructor() {
    super(), this.disabled = !1, this.autofocus = !1, this._tabIndex = 0, this.manipulatingTabindex = !1;
  }
  get tabIndex() {
    if (this.focusElement === this) {
      const t = this.hasAttribute("tabindex") ? parseFloat(this.getAttribute("tabindex")) : NaN;
      return isNaN(t) ? -1 : t;
    }
    const e = parseFloat(
      this.hasAttribute("tabindex") && this.getAttribute("tabindex") || "0"
    );
    return this.disabled || e < 0 ? -1 : this.focusElement ? this.focusElement.tabIndex : e;
  }
  set tabIndex(e) {
    if (this.manipulatingTabindex) {
      this.manipulatingTabindex = !1;
      return;
    }
    if (this.focusElement === this) {
      if (e !== this.tabIndex) {
        this._tabIndex = e;
        const t = this.disabled ? "-1" : `${e}`;
        this.setAttribute("tabindex", t);
      }
      return;
    }
    if (e === -1 ? this.addEventListener(
      "pointerdown",
      this.onPointerdownManagementOfTabIndex
    ) : (this.manipulatingTabindex = !0, this.removeEventListener(
      "pointerdown",
      this.onPointerdownManagementOfTabIndex
    )), e === -1 || this.disabled) {
      this.setAttribute("tabindex", "-1"), this.removeAttribute("focusable"), e !== -1 && this.manageFocusElementTabindex(e);
      return;
    }
    this.setAttribute("focusable", ""), this.hasAttribute("tabindex") ? this.removeAttribute("tabindex") : this.manipulatingTabindex = !1, this.manageFocusElementTabindex(e);
  }
  onPointerdownManagementOfTabIndex() {
    this.tabIndex === -1 && (this.tabIndex = 0, this.focus({ preventScroll: !0 }));
  }
  async manageFocusElementTabindex(e) {
    this.focusElement || await this.updateComplete, e === null ? this.focusElement.removeAttribute("tabindex") : this.focusElement.tabIndex = e;
  }
  get focusElement() {
    return this;
  }
  focus(e) {
    this.disabled || !this.focusElement || (this.focusElement !== this ? this.focusElement.focus(e) : HTMLElement.prototype.focus.apply(this, [e]));
  }
  blur() {
    const e = this.focusElement || this;
    e !== this ? e.blur() : HTMLElement.prototype.blur.apply(this);
  }
  click() {
    if (this.disabled)
      return;
    const e = this.focusElement || this;
    e !== this ? e.click() : HTMLElement.prototype.click.apply(this);
  }
  manageAutoFocus() {
    this.autofocus && (this.dispatchEvent(new KeyboardEvent("keydown", { code: "Tab" })), this.focusElement.focus());
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.manageAutoFocus(), (!this.hasAttribute("tabindex") || this.getAttribute("tabindex") !== "-1") && this.setAttribute("focusable", "");
  }
  update(e) {
    e.has("disabled") && this.handleDisabledChanged(
      this.disabled,
      e.get("disabled")
    ), super.update(e);
  }
  updated(e) {
    super.updated(e), e.has("disabled") && this.disabled && this.blur();
  }
  async handleDisabledChanged(e, t) {
    const i = () => this.focusElement !== this && typeof this.focusElement.disabled < "u";
    e ? (this.manipulatingTabindex = !0, this.setAttribute("tabindex", "-1"), await this.updateComplete, i() ? this.focusElement.disabled = !0 : this.setAttribute("aria-disabled", "true")) : t && (this.manipulatingTabindex = !0, this.focusElement === this ? this.setAttribute("tabindex", `${this._tabIndex}`) : this.removeAttribute("tabindex"), await this.updateComplete, i() ? this.focusElement.disabled = !1 : this.removeAttribute("aria-disabled"));
  }
}
I([
  l({ type: Boolean, reflect: !0 })
], A.prototype, "disabled", 2);
I([
  l({ type: Boolean })
], A.prototype, "autofocus", 2);
I([
  l({ type: Number })
], A.prototype, "tabIndex", 1);
var xe = Object.defineProperty, _ = (n, e, t, i) => {
  for (var s = void 0, a = n.length - 1, c; a >= 0; a--)
    (c = n[a]) && (s = c(e, t, s) || s);
  return s && xe(e, t, s), s;
};
class g extends A {
  constructor() {
    super(...arguments), this.disabled = !1, this.labelText = "", this.selected = !1, this.value = "", this.displayName = "";
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-select-item");
  }
}
_([
  l({ type: Boolean, reflect: !0 })
], g.prototype, "disabled");
_([
  l({ reflect: !0, attribute: "label-text" })
], g.prototype, "labelText");
_([
  l({ type: Boolean, reflect: !0 })
], g.prototype, "selected");
_([
  l({ reflect: !0 })
], g.prototype, "value");
_([
  l({ reflect: !0, attribute: "display-name" })
], g.prototype, "displayName");
try {
  customElements.define("adc-select-item", g), console.warn("@aileron/select is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/select");
} catch {
}
function Ee(n) {
  try {
    customElements.define(`${n}-select-item`, class extends g {
    });
  } catch {
  }
}
function Ae(n) {
  try {
    be(n), Ee(n), me(n);
  } catch {
  }
}
export {
  r as Select,
  g as SelectItem,
  L as SelectItemGroup,
  Ae as registerComponent,
  me as registerSelect,
  Ee as registerSelectItem,
  be as registerSelectItemGroup
};
